import DOMPurify from 'dompurify';
import styles from './ConclusionSection.module.css';

interface ConclusionSectionProps {
  conclusionHtml: string;
}

/**
 * Renders the report conclusion as sanitized HTML.
 * DOMPurify strips all XSS vectors before rendering.
 */
export default function ConclusionSection({
  conclusionHtml,
}: ConclusionSectionProps) {
  // Sanitize HTML to prevent XSS — DOMPurify removes all dangerous tags/attributes
  const sanitized = DOMPurify.sanitize(conclusionHtml);

  return (
    <section className={styles.section}>
      <h3 className={styles.sectionTitle}>Conclusions</h3>
      {sanitized ? (
        <div
          className={styles.content}
          // eslint-disable-next-line react/no-danger -- sanitized via DOMPurify
          dangerouslySetInnerHTML={{ __html: sanitized }}
        />
      ) : (
        <p className={styles.empty}>No conclusion provided.</p>
      )}
    </section>
  );
}
